import {bundleConstants} from "../../constants";

const initialState = {
  BundleList: {},
  isLoading: false,
  isFailure: false,
  isDelete: false,
  isSubmit: false,
  receiverList: [],
}

export default function bundle(state = initialState, action) {
  switch (action.type) {
    /***********
     꾸러미 신청 검색조건 변경
     ************/
    case bundleConstants.SELECT_SEARCH_REQUEST:
      return {
        ...state,
        selectInfo: action.payload
      }

    /*********
     꾸러미 신청 목록 조회
     **********/
    case bundleConstants.BUNDLE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case bundleConstants.BUNDLE_SUCCESS:
      return {
        ...state,
        BundleList: action.response.data?.payload,
        isDelete: false,
      }
    case bundleConstants.BUNDLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

      /*********
       꾸러미 신청 상세 조회
       **********/
    case bundleConstants.DETAIL_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case bundleConstants.DETAIL_SUCCESS:
      return {
        ...state,
        bundleInfo: action.response.data?.payload,
        isFailure: false
      }
    case bundleConstants.DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /***********
     꾸러미 상세 선택
     ************/
    case bundleConstants.SELECT_REQUEST:
      return {
        ...state,
        info: action.payload
      }

      /***********
       꾸러미 히스토리 관리
       ************/
    case bundleConstants.BUNDLE_HISTORY:
      return {
        ...state,
        history: action.payload
      }

    default:
      return state
  }
}
